<div class="custom-radio-group">
  <div class="d-flex ai-baseline" [ngClass]="{'column': isLabelInColumn}">
    <label class="color-navi fs-sm medium" [ngClass]="isLabelInColumn ? 'mb-1' : 'pr-q'">
      <span *ngIf="label">
        <span>{{label}}</span>
        <span *ngIf="isRequired" class="color-error">*</span>:
      </span>
    </label>
    <mat-radio-group aria-label="Select an option"
                     [formControl]="ctrl.control">
      <mat-radio-button *ngFor="let item of buttonValues; index as i"
                        class="mr-h"
                        [disableRipple]="true"
                        [value]="item.code"
                        [attr.data-test-id]="'radio_'+testId+i"
                        (click)="selectItem(item.code)">{{item.name}}</mat-radio-button>
    </mat-radio-group>
  </div>

  <mat-hint *ngIf="inputHint && !isWarningVisible" class="d-flex mt-hq color-navi">
    <span *ngIf="hintIconExist" class="icon icon-info icon-fs-md mr-q"></span>
    <span class="fs-sm">{{inputHint}}</span>
  </mat-hint>

  <mat-hint *ngIf="isWarningVisible" class="color-warning d-flex ai-center mt-h">
    <span class="icon icon-error icon-fs-md mr-q"></span>
    <span class="fs-sm">{{warningMessage}}</span>
  </mat-hint>

  <mat-error *ngIf="ctrl.invalid && ctrl.touched">
    <span class="icon icon-error fs-md"></span>
    {{getErrorMessage()}}
  </mat-error>
</div>
